{
  "tabs": {
    "chat": "Chatt",
    "reminders": "Påminnelser",
    "calendar": "Kalender",
    "settings": "Inställningar"
  },
  "common": {
    "cancel": "Avbryt",
    "save": "Spara",
    "confirm": "Bekräfta",
    "delete": "Radera",
    "back": "Tillbaka",
    "close": "Stäng",
    "edit": "Redigera",
    "search": "Sök",
    "all": "Alla",
    "loading": "Laddar...",
    "error": "Något gick fel",
    "notFound": "Hittades inte",
    "tryAgain": "Försök igen",
    "retry": "Försök igen",
    "undo": "Ångra",
    "pullToRefresh": "Dra för att uppdatera",
    "justNow": "just nu"
  },
  "auth": {
    "welcome": "Välkommen till FishMemory",
    "tagline": "Din WhatsApp-påminnelseassistent, nu i din ficka.",
    "subtitle": "Din WhatsApp-påminnelseassistent, nu i din ficka.",
    "phoneLabel": "Ditt WhatsApp-nummer",
    "phoneHint": "Vi skickar en verifieringskod via WhatsApp",
    "invalidPhone": "Ange ett giltigt telefonnummer",
    "continue": "Fortsätt",
    "enterPhone": "Ange ditt WhatsApp-nummer",
    "phonePlaceholder": "Telefonnummer",
    "sendCode": "Skicka kod",
    "verifyTitle": "Verifiera ditt nummer",
    "otpSentTo": "En 6-siffrig kod skickades till {{phone}} via WhatsApp",
    "enterFullCode": "Ange alla 6 siffror",
    "invalidOtp": "Ogiltig kod. Försök igen.",
    "otpFailed": "Misslyckades att skicka kod. Försök igen.",
    "otpResent": "Kod skickad igen",
    "resendIn": "Skicka igen om {{seconds}}s",
    "resendCode": "Skicka kod igen",
    "enterOtp": "Ange koden skickad till din WhatsApp",
    "verify": "Verifiera",
    "resend": "Skicka kod igen",
    "wrongNumber": "Fel nummer?",
    "backToPhone": "Tillbaka till nummer",
    "editPhone": "Redigera nummer",
    "error": "Fel",
    "setupTitle": "Låt oss ställa in",
    "setupSubtitle": "Du kan alltid ändra detta senare i Inställningar",
    "namePlaceholder": "Ditt namn",
    "letsGo": "Slutför inställning",
    "skipForNow": "Hoppa över för nu"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Skriv ett meddelande...",
    "inputPlaceholder": "Skriv ett meddelande...",
    "typing": "FishMemory skriver...",
    "online": "Online",
    "connecting": "Ansluter...",
    "reconnecting": "Ansluter igen...",
    "offline": "Offline",
    "empty": "Starta en konversation",
    "emptyHint": "Skapa påminnelser, kolla ditt schema eller be om hjälp.",
    "emptyAction": "Skicka ett exempel påminnelse",
    "actions": "Chattåtgärder",
    "keep": "Behåll meddelanden",
    "clearTitle": "Rensa chatt",
    "clearConfirm": "Radera alla meddelanden från denna enhet? Detta kan inte ångras.",
    "clear": "Rensa chatt",
    "optionSelected": "Vald: {{label}}",
    "sendingSelection": "Skickar...",
    "connectionLost": "Ansluter igen..."
  },
  "reminders": {
    "title": "Mina påminnelser",
    "active": "Aktiva",
    "today": "Idag",
    "thisWeek": "Denna vecka",
    "history": "Historik",
    "items": "objekt",
    "emptyTitle": "Inga påminnelser än",
    "emptySubtitle": "Skapa en från chatten så visas den här.",
    "emptyAction": "Öppna chatt",
    "filterActive": "Aktiva",
    "filterToday": "Idag",
    "filterWeek": "Denna vecka",
    "filterHistory": "Historik",
    "emptyState": "Inga påminnelser än. Börja chatta!",
    "swipeDone": "Klar",
    "swipeSnooze": "Snooza",
    "swipeDelete": "Radera",
    "search": "Sök påminnelser...",
    "upcoming": "Kommande",
    "completed": "Avslutade",
    "overdue": "Försenade",
    "tomorrow": "Imorgon",
    "synced": "Synkroniserad {{value}}",
    "swipeHint": "Svep en påminnelse för fler åtgärder",
    "noResults": "Inga påminnelser matchar din sökning",
    "noResultsHint": "Prova ett annat sökord eller rensa sökningen",
    "deleteAllFailed": "Misslyckades att radera alla påminnelser"
  },
  "calendar": {
    "title": "Kalender",
    "today": "Idag",
    "tomorrow": "Imorgon",
    "completed": "klar",
    "noEvents": "Inga schemalagda",
    "noEventsSubtitle": "Välj ett datum för att se påminnelser och kalenderhändelser.",
    "googleEvent": "Google Kalender",
    "legendActive": "Aktiv",
    "legendRecurring": "Återkommande",
    "legendDone": "Klar",
    "legendGoogle": "Google",
    "previousMonth": "Föregående månad",
    "nextMonth": "Nästa månad",
    "previousYear": "Föregående år",
    "nextYear": "Nästa år",
    "goToToday": "Gå till idag",
    "all": "Alla",
    "active": "Aktiva",
    "done": "Klara",
    "paused": "Pausade"
  },
  "settings": {
    "title": "Inställningar",
    "profile": "Profil",
    "name": "Visningsnamn",
    "enterName": "Ange ditt namn",
    "language": "Språk",
    "uiLanguage": "App-språk",
    "uiLanguageHelp": "Ändrar appens gränssnitt, kalenderetiketter och layout på denna enhet endast.",
    "serverLanguage": "Chatt-språk",
    "serverLanguageHelp": "Ändrar språket som används av serverns svar och påminnelsemeddelanden för ditt konto.",
    "timezone": "Tidszon",
    "currentTimezone": "Aktuell tidszon",
    "timezoneHelp": "Alla påminnelsetider visas med denna tidszon.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Spara tidszon",
    "timezoneSaved": "Tidszon uppdaterad",
    "detect": "Detektera",
    "detectFailed": "Kunde inte detektera tidszon",
    "autoDetect": "Automatisk detektering via GPS",
    "notifications": "Notiser",
    "notificationsHelp": "Uppföljningspåminnelser styr upprepade aviseringar efter att en påminnelse levererats. Enhetsnivå notistillstånd hanteras fortfarande i telefonens inställningar.",
    "pushEnabled": "Push-notiser",
    "autoDoneOnFire": "Markera automatiskt som klar vid avisering",
    "autoDoneOnFireDesc": "När avstängt förblir påminnelser aktiva tills du markerar dem som klara.",
    "googleCalendar": "Google Kalender",
    "google": "Google Kalender",
    "googleConnected": "Ansluten",
    "googleDisconnected": "Inte ansluten",
    "googleConnectedHelp": "Nya påminnelser kan synkas automatiskt till din kalender.",
    "googleDisconnectedHelp": "Anslut Google Kalender för att hålla påminnelser och händelser synkade.",
    "googleConnectFailed": "Misslyckades att ansluta Google Kalender",
    "connected": "Ansluten",
    "disconnected": "Inte ansluten",
    "connect": "Anslut",
    "disconnect": "Koppla från",
    "autoSync": "Autosynka nya påminnelser",
    "autosync": "Autosynka nya påminnelser",
    "subscription": "Prenumeration",
    "trialUsed": "Testperiod: {{used}}/{{total}} använd",
    "trialStatus": "Testperiod tillgänglig",
    "activeStatus": "Aktiv prenumeration",
    "expiredStatus": "Prenumerationen har gått ut",
    "unsubscribedStatus": "Ej prenumererad",
    "about": "Om",
    "version": "Version",
    "logout": "Logga ut",
    "logoutTitle": "Logga ut",
    "logoutConfirm": "Är du säker på att du vill logga ut?",
    "noName": "Inget namn angivet",
    "serverConnection": "Serveranslutning",
    "serverUrl": "Server-URL",
    "serverEdit": "Redigera",
    "saveReconnect": "Spara och anslut igen",
    "resetDefault": "Återställ standard",
    "invalidServerUrlTitle": "Ogiltig server-URL",
    "invalidServerUrlMessage": "Ange en giltig http- eller https-server-URL, till exempel https://example.com",
    "uiLanguageChangeFailed": "Misslyckades att ändra appspråk. Försök igen.",
    "serverLanguageChangeFailed": "Misslyckades att ändra chatt-språk. Försök igen.",
    "timezoneChangeFailed": "Misslyckades att ändra tidszon. Försök igen.",
    "autoSyncChangeFailed": "Misslyckades att uppdatera autosynk. Försök igen.",
    "nameChangeFailed": "Misslyckades att uppdatera visningsnamn. Försök igen.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Påminnelsedetaljer",
    "editTime": "Redigera tid",
    "rename": "Byt namn",
    "snooze": "Snooza",
    "snooze15": "Snooza 15 minuter",
    "pause": "Pausa",
    "pauseReminder": "Pausa påminnelse",
    "resume": "Återuppta",
    "resumeReminder": "Återuppta påminnelse",
    "skip": "Hoppa över nästa",
    "skipOccurrence": "Hoppa över detta tillfälle",
    "syncGoogle": "Synka till Google",
    "delete": "Radera",
    "deleteTitle": "Radera påminnelse",
    "deleteConfirm": "Denna påminnelse kommer att raderas permanent.",
    "deleteRecurringTitle": "Radera återkommande påminnelse",
    "deleteRecurringMessage": "Vill du hoppa över detta tillfälle eller radera hela serien?",
    "deleteThisOccurrence": "Hoppa över detta tillfälle",
    "deleteEntireSeries": "Radera hela serien",
    "done": "Klar",
    "markDone": "Markera som klar",
    "undo": "Återställ",
    "undoPrompt": "Behöver du den aktiv igen? Återställ nu.",
    "recurring": "Återkommande",
    "nextRun": "Nästa körning",
    "oneTime": "Engångs",
    "pending": "Väntande",
    "sent": "Skickad",
    "paused": "Pausad",
    "active": "Aktiv",
    "snoozed": "Snoozad",
    "localTime": "Visas i din lokala tid",
    "recurrence": "Återkommande",
    "created": "Skapad",
    "tags": "Taggar",
    "fireCount": "Antal gånger aktiverad",
    "actions": "Åtgärder",
    "none": "Ingen",
    "snoozeFailed": "Misslyckades att snooza påminnelse",
    "pauseFailed": "Misslyckades att pausa påminnelse",
    "resumeFailed": "Misslyckades att återuppta påminnelse",
    "skipFailed": "Misslyckades att hoppa över påminnelse",
    "doneFailed": "Misslyckades att markera påminnelse som klar",
    "undoFailed": "Misslyckades att återställa påminnelsestatus",
    "deleteFailed": "Misslyckades att radera påminnelse",
    "rescheduleTitle": "Schemalägg om?",
    "rescheduleMsg": "Denna påminnelse är försenad. Vill du schemalägga om den?",
    "reschedule15": "Om 15 minuter",
    "reschedule60": "Om 1 timme",
    "keepOverdue": "Behåll som den är"
  },
  "onboarding": {
    "slide1Title": "Välkommen till FishMemory",
    "slide1Sub": "Din personliga påminnelseassistent – drivs av WhatsApp och byggd för din ficka.",
    "slide2Title": "Chatta naturligt",
    "slide2Sub": "Skriv påminnelser som du tänker: \"Påminn mig att ringa mamma imorgon kl 15\" – vi sköter resten.",
    "slide3Title": "Missa aldrig något",
    "slide3Sub": "Få tidsenliga notiser, organisera med taggar och håll koll på allt som är viktigt.",
    "getStarted": "Kom igång",
    "next": "Nästa",
    "firstReminderTitle": "Skapa din första påminnelse!",
    "firstReminderHint": "Prova att skriva något som:",
    "firstReminderExample": "Påminn mig att dricka vatten imorgon kl 9",
    "gotIt": "Förstått!",
    "notifRationaleTitle": "Håll tiden",
    "notifRationaleBody": "FishMemory behöver notiser för att påminna dig i tid. Du får bara aviseringar för påminnelser du skapar.",
    "notifRationaleAllow": "Aktivera notiser",
    "notifRationaleLater": "Kanske senare",
    "swipeHint": "Svep höger för snabba åtgärder →",
    "calendarDragHint": "Dra för att expandera ↕"
  }
}
